import { LandingData } from "../core/buildLandingData";


export const mapUIToLandingSettings = (
  landingData: LandingData
) => {
  const styles = landingData.theme.globalStyles;

  return {
    theme: {
      backgroundType: landingData.theme.backgroundType,

      backgroundImage:
        landingData.theme.backgroundImage ?? null,

      backgroundColor:
        landingData.theme.backgroundColor ?? null,

      globalStyles: {
        fontFamily: styles?.fontFamily ?? "Inter",

        // Colores
        h1Color: styles?.h1Color ?? "#ffffff",
        h2Color: styles?.h2Color ?? "#ffffff",
        h3Color: styles?.h3Color ?? "#ffffff",
        textColor: styles?.textColor ?? "#a1a1aa",

        // Botones
        buttonColor: styles?.buttonColor ?? "#00f4fb",
        buttonTextColor: styles?.buttonTextColor ?? "#000000",

        // Marca
        accentColor: styles?.accentColor ?? "#00f4fb",
      },
    },
  };
};